// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_cd-0";
export var headerCellHover = "_cd-1";